<script lang="ts">
  import BoardDueBadge from '$lib/components/ui/BoardDueBadge.svelte';
  import { t } from '$lib/i18n';
  import type { BoardCard, BoardUpdateStatus } from '$lib/types';

  let { cards, loading, failed, onCreate, onDismiss, onUpdate }: {
    cards: BoardCard[];
    loading: boolean;
    failed: boolean;
    onCreate: () => void;
    onDismiss: () => void;
    onUpdate: (card: BoardCard, status?: BoardUpdateStatus) => void;
  } = $props();
</script>

<section class="mb-4 rounded-[14px] border border-toyama-cloudy-gray bg-surface p-3" aria-label={t('board.reminders.title')}>
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h2 class="font-heading font-semibold text-navy">{t('board.reminders.title')} <span class="text-sm text-dark-gray">{cards.length}</span></h2>
    <button type="button" class="btn-primary min-h-[44px]" onclick={onCreate}>{t('board.addCard')}</button>
    <button type="button" class="btn-secondary min-h-[44px]" onclick={onDismiss}>{t('board.reminders.dismiss')}</button>
  </div>
  {#if loading}<p class="mt-2 text-sm text-dark-gray">{t('common.loading')}</p>
  {:else if failed}<p class="tym-error-state">{t('board.error')}</p>
  {:else}
    <ul class="mt-2 space-y-2">
      {#each cards as card (card.id)}
        <li class="rounded-lg bg-surface-2 p-3">
          <p class="break-words text-sm font-semibold text-navy">{card.title}</p>
          <BoardDueBadge {card} />
          {#if card.col === 'blocked'}<p class="mt-1 text-xs text-red-700">{t('board.column.blocked')}{card.blocked_reason ? ` · ${card.blocked_reason}` : ''}</p>{/if}
          {#if card.last_nudged_at}<p class="mt-1 text-xs text-dark-gray">{t('board.reminders.nudged')}</p>{/if}
          <div class="mt-2 flex flex-wrap gap-2">
            <button type="button" class="btn-secondary min-h-[44px]" onclick={() => onUpdate(card)}>{t('board.updates.add')}</button>
            <button type="button" class="btn-secondary min-h-[44px]" onclick={() => onUpdate(card, 'on_track')}>{t('board.quick.start')}</button>
            <button type="button" class="btn-secondary min-h-[44px]" onclick={() => onUpdate(card, 'done')}>{t('board.quick.done')}</button>
            <button type="button" class="btn-secondary min-h-[44px]" onclick={() => onUpdate(card, 'blocked')}>{t('board.column.blocked')}</button>
          </div>
        </li>
      {:else}<li class="py-2 text-sm text-dark-gray">{t('board.reminders.empty')}</li>{/each}
    </ul>
  {/if}
</section>
